

function transformTaskVirtualMeetingForDrawer(response) {
  if (response == null || typeof response !== "object") return null

  return {
    id: response.id,
    title: "Video Meeting",
    actualStartTime: response.actualStartTime ?? null,
    actualEndTime: response.actualEndTime ?? null,
    virtualDetails: {
      id: response.id,
      provider: response.provider,
      externalEventId: response.externalEventId,
      conferenceRecordName: response.conferenceRecordName,
      meetingUrl: response.meetingUrl,
      stage: response.stage,
      scheduledStartTime: response.scheduledStartTime ?? null,
      scheduledEndTime: response.scheduledEndTime ?? null,
      actualStartTime: response.actualStartTime ?? null,
      actualEndTime: response.actualEndTime ?? null,
      VirtualMeetingArtifact: response.VirtualMeetingArtifact,
      VirtualMeetingAttendees: response.VirtualMeetingAttendees ?? [],
    },
    meetingType: null,
    organizer: null,
    participantList: [],
    attendees: [],
    aiTotalScore: null,
    audioAnalysis: null,
    transcription: null,
  }
}

export default transformTaskVirtualMeetingForDrawer
